<template>
  <div class="noselect">
    <ul v-if="[ '', null, undefined ].indexOf(cpntPastas) === -1 && cpntPastas.length >= 1" :key="index" :style="cpntNivel === 0 ? 'margin-left: 0px;' : ''">
      <template v-for="(pasta, indexP) in cpntPastas">
        <li :key="pasta.chave" v-if="[ '', null, undefined ].indexOf(pasta.qtde) === -1" @click="armArqGerPastaAbrir(indexP)">
          <!-- ADICIONA O ICONE -->
          <div class="icone">
            <svg v-if="pasta.chave === 'status'" class="far fa-trash-alt"></svg>
            <svg v-else-if="armArqGerPastaVerificarSelecionado(indexP) === false" class="far fa-folder"></svg>
            <svg v-else-if="armArqGerPastaVerificarSelecionado(indexP) === true" class="far fa-folder-open"></svg>
          </div>

          <!-- ADICIONA O NOME DA PASTA -->
          <span v-html="pasta.nome"></span>

          <!-- MOSTRAR A PORCENTAGEM -->
          <span class="porcetagem" v-if="[ '', null, undefined, NaN, 'NaN' ].indexOf(pasta.porcentagem) === -1" v-html="' (' + pasta.porcentagem + '%)'"></span>

          <!-- ADICIONA SUBPASTAS SE EXISTIR -->
          <div @click.stop v-if="armArqGerPastaVerificarSelecionado(indexP) === true && [ '', null, undefined ].indexOf(cpntPastas[indexP].subpastas) === -1">
            <Armazenamento-Arquivos-Pastas
              :cpntPastas="cpntPastas[indexP].subpastas"
              :cpntNivel="cpntNivel + 1"
              :cpntSelecionado="cpntSelecionado"
              :cpntOnChangeSelectNivel="cpntOnChangeSelectNivel"
            ></Armazenamento-Arquivos-Pastas>
          </div>
        </li>
      </template>
    </ul>

  </div>
</template>

<style scoped>
  ul {
    list-style-type: none;
    margin-left: 20px;
    /* margin-left: 2.5em; */
    padding-left: 0;
  }
    ul > li {
      padding: 5px 0px;
      cursor: pointer;
    }
    /* ul > li:hover,
    ul > li.selecionado {
      background: blue;
    } */

      ul > li > .icone {
        /* left: -2em;
        position: absolute; */
        display: inline-block;
        text-align: center;
        width: 25px;
      }
        ul > li > .icone > svg {
          font-size: 18px;
        } 
      ul > li > .porcetagem {
        font-size: 10px;
        font-style: italic;
      }
</style>

<script>
export default {
  name: 'Armazenamento-Arquivos-Pastas',
  props: {
    cpntPastas: {
      type: Array,
      required: true
    },
    cpntSelecionado: {
      type: Object,
      required: true
    },
    cpntNivel: {
      type: Number,
      required: true
    },
    cpntOnChangeSelectNivel: {
      required: true
    }
  },
  data: function () {
    return {
      time: '',
      statusGeral: '',
      index: ''
    }
  },
  mounted: function () {
    this.armArqGerPastaIniciar()
  },
  methods: {
    armArqGerPastaIniciar: function () {
      // SETA O STATUS DA PAGINA
      this.armArqGerPastaSetarStatusGeral('carregando')
    },
    armArqGerPastaSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    
    armArqGerPastaAbrir: function (indexP) {
      this.cpntOnChangeSelectNivel(this.cpntNivel, indexP)
    },
    armArqGerPastaVerificarSelecionado: function (indexP) {
      return [ '', null, undefined ].indexOf(this.cpntSelecionado[this.cpntNivel]) === -1 && this.cpntSelecionado[this.cpntNivel] === indexP
    }
  },
  computed: {
    armArqGerPastaVerificarSelecionadoT: function (indexP) {
      return [ '', null, undefined ].indexOf(this.cpntSelecionado[this.cpntNivel]) === -1 && this.cpntSelecionado[this.cpntNivel] === indexP
    }
  }
}
</script>